import React from "react";

const IconComponentMap={
  defaultEntityIcon:React.lazy(()=>import("@mui/icons-material/Folder")),
  homeIcon:React.lazy(()=>import("@mui/icons-material/Home")),
  accountIcon:React.lazy(()=>import("@mui/icons-material/AccountBox")),
  userIcon:React.lazy(()=>import("@mui/icons-material/People")),
  taskIcon:React.lazy(()=>import("@mui/icons-material/AssignmentTurnedIn")),
  notesIcon:React.lazy(()=>import("@mui/icons-material/Notes")),
  repoortIcon:React.lazy(()=>import("@mui/icons-material/Assessment")),
  scheduleIcon:React.lazy(()=>import("@mui/icons-material/CalendarMonth")),
  eventIcon:React.lazy(()=>import("@mui/icons-material/Event")),
  dataMgmtIcon:React.lazy(()=>import("@mui/icons-material/Storage")),
  serverMgmtIcon:React.lazy(()=>import("@mui/icons-material/Memory")),
  notificationsIcon:React.lazy(()=>import("@mui/icons-material/Notifications")),
  appRolesIcon:React.lazy(()=>import("@mui/icons-material/AdminPanelSettingsOutlined")),
  appMenuIcon:React.lazy(()=>import("@mui/icons-material/AppsOutlined")),
  holidayIcon:React.lazy(()=>import("@mui/icons-material/HolidayVillage")),
  workdayIcon:React.lazy(()=>import("@mui/icons-material/Timer")),
};

export const getIconComponent=(name)=>IconComponentMap[name]||null;
